import { render, staticRenderFns } from "./TkHeaderAccount.vue?vue&type=template&id=56ac9f8b&scoped=true&"
import script from "./TkHeaderAccount.vue?vue&type=script&lang=js&"
export * from "./TkHeaderAccount.vue?vue&type=script&lang=js&"
import style0 from "./TkHeaderAccount.vue?vue&type=style&index=0&id=56ac9f8b&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "56ac9f8b",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VIcon } from 'vuetify/lib/components/VIcon';
installComponents(component, {VIcon})
